import { comparisonData } from '@/mocks/categories';

export default function ComparisonTable() {
  return (
    <section id="compare" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            VigorBuy vs Traditional Search
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            See how the VigorBuy Spreadsheet compares to searching on your own.
          </p>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200/70">
          <table className="w-full">
            <thead>
              <tr className="bg-background-200/50">
                <th className="text-left px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold font-heading text-foreground-800">
                  Feature
                </th>
                <th className="text-center px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold font-heading text-primary-600">
                  <i className="ri-check-line w-4 h-4 inline-flex items-center"></i>{' '}
                  VigorBuy Spreadsheet
                </th>
                <th className="text-center px-4 md:px-6 py-3 md:py-4 text-xs md:text-sm font-semibold font-heading text-foreground-600">
                  Traditional Search
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-t border-background-200/70 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  }`}
                >
                  <td className="px-4 md:px-6 py-3 md:py-3.5 text-xs md:text-sm text-foreground-700">
                    {row.feature}
                  </td>
                  <td className="px-4 md:px-6 py-3 md:py-3.5 text-center">
                    {row.spreadsheet === true ? (
                      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-accent-100">
                        <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-accent-600"></i>
                      </span>
                    ) : (
                      <span className="text-xs md:text-sm text-foreground-600">{row.spreadsheet}</span>
                    )}
                  </td>
                  <td className="px-4 md:px-6 py-3 md:py-3.5 text-center">
                    {row.traditional === false ? (
                      <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-background-200/70">
                        <i className="ri-close-line w-3.5 h-3.5 flex items-center justify-center text-foreground-400"></i>
                      </span>
                    ) : (
                      <span className="text-xs md:text-sm text-foreground-500">{row.traditional}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}